import apiHeader from "@/helpers/apiHeader";

const woApprovalService = {
  approve(params) {
    return apiHeader.post("general-setting/workflow-config/approve", params );
  },
  reject(params) {
    return apiHeader.post("general-setting/workflow-config/reject", params );
  },
  sendBack(params) {
    return apiHeader.post("general-setting/workflow-config/send-back", params );
  },
  // Body { key: <mcr_code> } -> { current_step, default_send_back, options: [{ value, label, description, roles, is_default, ... }] }
  // (opsi tujuan Send Back dari step workflow saat ini).
  getStep(params) {
    return apiHeader.post("general-setting/workflow-config/get-step", params );
  },
  start(params) {
    return apiHeader.post("general-setting/workflow-config/start", params );
  },
  getByModule(module) {
    return apiHeader.get("general-setting/workflow-config/by-module", { params: { module } });
  },
};

export default woApprovalService;
